import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Avatar, Button, Grid, Typography } from '@upperhand/playmaker';
import MainHeader from 'components/MainHeader';

import { resetScrollPosition } from 'utils/browser';

const Confirmation = () => {
  const history = useHistory();

  const { id: sessionId } = useParams();
  const BACK_URL = `/sessions/${sessionId}`;

  const { client, sessionName } = history.location.state || {};
  React.useEffect(() => resetScrollPosition(), []);

  React.useEffect(() => {
    const timeout = setTimeout(() => history.push(BACK_URL), 3000);
    return () => clearTimeout(timeout);
  });

  if (!client) {
    history.replace(BACK_URL);
    return null;
  }

  const { avatarName, src } = client.avatarData;

  const handleClickDone = () => history.push(BACK_URL);

  return (
    <>
      <MainHeader showLogout={false} backToLink={`/sessions/${sessionId}`} />
      <main className="MainContent">
        <Grid container direction="column" alignItems="center" spacing={3}>
          <Grid item xs={12}>
            <Avatar size={200} src={src}>
              {!src && avatarName}
            </Avatar>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3" component="p">
              {client.fullName}
            </Typography>
          </Grid>
        </Grid>

        {/* TODO: obviously not the best way to do this */}
        <div style={{ marginBottom: '88px' }} />

        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid item xs={12}>
            {/* TODO: should be green circle icon */}
            <Avatar size={74}>&#10003;</Avatar>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Checked in for:</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h1">{sessionName}</Typography>
          </Grid>
        </Grid>

        {/* TODO: gross */}
        <div style={{ marginBottom: '60px' }} />

        <Grid container direction="column" alignItems="center">
          <Button size="4x" onClick={handleClickDone}>
            <Typography variant="h3">Done</Typography>
          </Button>
        </Grid>
      </main>
    </>
  );
};

export default Confirmation;
